import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconGift1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconGift1"><Path d="M12 7.5V5.83333M12 7.5H10.3333C8.49238 7.5 7 6.00762 7 4.16667C7 3.24619 7.74619 2.5 8.66667 2.5C10.5076 2.5 12 3.99238 12 5.83333M12 7.5H13.6667C15.5076 7.5 17 6.00762 17 4.16667C17 3.24619 16.2538 2.5 15.3333 2.5C13.4924 2.5 12 3.99238 12 5.83333M12 7.5H3.5V11.5H4.5M12 7.5H20.5V11.5H19.5M12 7.5V11.5M19.5 11.5V20.5H12M19.5 11.5V11M19.5 11.5H12M4.5 11.5V20.5H12M4.5 11.5V11M4.5 11.5H12M12 20.5V11.5" stroke="currentColor"/></CentralIconBase>;
});

export default IconGift1;
